import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { IndexLink, Link } from 'react-router';
import { Icon } from 'components';
import * as styles from './AppSidebarItem.scss';

var AppSidebarItem = /*#__PURE__*/function (_Component) {
  _inherits(AppSidebarItem, _Component);

  var _super = _createSuper(AppSidebarItem);

  function AppSidebarItem() {
    _classCallCheck(this, AppSidebarItem);

    return _super.apply(this, arguments);
  }

  _createClass(AppSidebarItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          svgIcon = _this$props.svgIcon,
          itemHeight = _this$props.itemHeight,
          index = _this$props.index,
          link = _this$props.link,
          iconName = _this$props.iconName,
          theme = _this$props.theme,
          tooltip = _this$props.tooltip,
          text = _this$props.text;
      var ACTIVE = {
        color: theme.colors.primaryColor
      };
      var icon;

      if (svgIcon) {
        icon = /*#__PURE__*/React.createElement("span", {
          className: styles.icon
        }, /*#__PURE__*/React.createElement(Icon, {
          name: svgIcon,
          size: 32
        }));
      } else if (iconName) {
        icon = /*#__PURE__*/React.createElement("i", {
          className: "icon ".concat(iconName, " ").concat(styles.icon)
        });
      } else if (text) {
        icon = /*#__PURE__*/React.createElement("span", {
          className: styles.icon
        }, text);
      }

      return /*#__PURE__*/React.createElement("div", {
        className: styles.item,
        style: {
          borderColor: theme.colors.darkGray
        }
      }, index ? /*#__PURE__*/React.createElement(IndexLink, {
        to: link,
        className: styles.link,
        activeStyle: ACTIVE,
        style: {
          color: '#7b7c7d'
        },
        title: tooltip
      }, icon) : /*#__PURE__*/React.createElement(Link, {
        to: link,
        className: styles.link,
        activeStyle: ACTIVE,
        style: {
          color: '#7b7c7d'
        },
        title: tooltip
      }, icon));
    }
  }]);

  return AppSidebarItem;
}(Component);

_defineProperty(AppSidebarItem, "propTypes", {
  index: PropTypes.bool,
  link: PropTypes.string.isRequired,
  iconName: PropTypes.string,
  theme: PropTypes.object.isRequired
});

export default AppSidebarItem;